/**
 * Centralized GA4 Event Tracking
 * All custom events dispatched to Google Analytics go through this module.
 **/

function sendEvent(eventName, params) {
    if (typeof window.gtag === 'function') {
        window.gtag('event', eventName, params);
    }
}

// TODO: Uncomment when Google Ads Conversion ID is available
// const GOOGLE_ADS_CONVERSION_ID = 'AW-XXXXXXXXX';
// function sendConversion(label, params) {
//     if (typeof window.gtag === 'function') {
//         window.gtag('event', 'conversion', {
//             send_to: `${GOOGLE_ADS_CONVERSION_ID}/${label}`,
//             ...params
//         });
//     }
// }

export function trackTicketIframeLoad(iframeUrl) {
    sendEvent('ticket_iframe_load', {
        iframe_url: iframeUrl
    });
}

export function trackSorteoSubmit(province) {
    sendEvent('sorteo_form_submit', {
        province: province,
        form_type: 'sorteo'
    });
}

export function trackVideoPlay(videoId) {
    sendEvent('video_play', {
        video_id: videoId,
        video_title: 'trailer'
    });
}

export function trackHeroCtaClick(buttonText, destination) {
    sendEvent('hero_cta_click', {
        button_text: buttonText,
        destination: destination
    });
}

export function trackSocialClick(platform, context) {
    sendEvent('social_click', {
        platform: platform,
        context: context
    });
}

export function trackSectionView(sectionId) {
    sendEvent('section_view', {
        section_id: sectionId
    });
}

export function trackPurchase(transactionData) {
    sendEvent('purchase', {
        transaction_id: transactionData.transactionId,
        value: transactionData.value,
        currency: 'EUR',
        items: transactionData.items || []
    });
    // TODO: Uncomment when Google Ads Conversion ID is available
    // sendConversion('CONVERSION_LABEL', {
    //     value: transactionData.value,
    //     currency: 'EUR',
    //     transaction_id: transactionData.transactionId
    // });
}
